import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import { Duration } from 'moment/moment';
import { Observable, interval, isObservable, of } from 'rxjs';
import { map, share, startWith, switchMap } from 'rxjs/operators';

@Pipe({ name: 'amTimeInThePastUpdateEveryMinute$' })
export class AmTimeInThePastUpdateEveryMinutePipe implements PipeTransform {
   private static interval$ = interval(60000).pipe(share());

   transform(inputValue: Date | Observable<Date> | moment.Moment | Observable<moment.Moment>): Observable<Duration> {
      const inputValue$ = isObservable(inputValue) ? inputValue : of(inputValue);

      return inputValue$.pipe(
         map((value) => moment(value)),
         switchMap((value: moment.Moment) =>
            AmTimeInThePastUpdateEveryMinutePipe.interval$.pipe(
               startWith(value),
               map(() => value)
            )
         ),
         map((value) => {
            if (moment() < value) {
               return moment.duration(1, 'second');
            } else {
               return moment.duration(moment().diff(value));
            }
         })
      );
   }
}
